import { render, staticRenderFns } from "./SubjectDoesNotExist.vue?vue&type=template&id=3ca1c01e"
import script from "./SubjectDoesNotExist.vue?vue&type=script&lang=ts"
export * from "./SubjectDoesNotExist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports